import React from "react";
import { useTranslation } from "react-i18next";
import { IconButton } from "@/shared/ui/IconButton";
import { ModalFileName } from "@/shared/modals";
import { Row } from "@/shared/ui/Blocks";
import { ScreenContainer } from "@/shared/ui/ScreenContainer";
import { Title } from "@/shared/ui/Title";
import { useModal } from "@/shared/utils/hooks/useModal";
import { TeamCard } from "@/features/teams/components/TeamCard";
import { CardGrid } from "@/shared/ui/CardGrid";
import { useOrganisation } from "@/features/organization/hooks/useOrganisation";
import { Breadcrumbs } from "@/shared/widgets/Breadcrumbs";
import { useTeams } from "@/features/teams/hooks/useTeams";
import useViewerPermissions from "@/features/workspace/hooks/useViewerPermissions";
import { ResourceEnum } from "@/shared/constants/resources";
import { AccessLevel } from "@/shared/constants";
import { HeaderContent } from "@/shared/widgets";

export default function () {
  const { organization } = useOrganisation();
  const [openNewTeamModal] = useModal(ModalFileName.NEW_TEAM);
  const { teams, loading } = useTeams(organization.id!);

  const { t } = useTranslation();

  const { validateAccessToResource, permissionsLoading } =
    useViewerPermissions();

  const hasReadAccess = validateAccessToResource({
    resourceType: ResourceEnum.organization,
    accessLevel: AccessLevel.limited,
  });

  const canCreateTeam = validateAccessToResource({
    resourceType: ResourceEnum.organization,
    accessLevel: AccessLevel.edit,
  });

  return (
    <>
      {canCreateTeam && (
        <HeaderContent>
          <IconButton
            variant="default"
            icon="Plus"
            label={t("team.create_team")}
            onClick={() => openNewTeamModal()}
          />
        </HeaderContent>
      )}
      <ScreenContainer
        loading={permissionsLoading}
        loadingMessage={t("common.loading_teams")}
        className="overflow-y-auto"
        permissionLocked={!hasReadAccess}
      >
        <Breadcrumbs />
        <Row className="justify-between md:items-end mb-8 gap-4 flex-col md:flex-row">
          <Title description={t("team.teams_list_description")}>
            {t("team.teams")}
          </Title>
        </Row>
        <CardGrid
          data={teams}
          loading={loading}
          renderCard={(team) => (
            <TeamCard team={team} key={team.id} loading={loading} />
          )}
        />
      </ScreenContainer>
    </>
  );
}
